import LinkDetailsIcons from "components/LinkDetailsIcons";
import { getDomainName } from "core/Utils";
import React, { Component } from "react";
import endSession from "core/api/endSession/endSession";
import Cookies from "universal-cookie";
import Loading from "components/Loading";
import { Button } from "mondrian-react";
const cookies = new Cookies();
const opened = "cred-ProfileMenuItem cred-ProfileMenuItem--open";
const closed = "cred-ProfileMenuItem";
const logoutLink = process.env.REACT_APP_END_SESSION_REDIRECT;
class HeaderMenu extends Component {
  container = React.createRef();

  state = {
    open: false,
    menuClass: closed,
    loading: false
  };


  handleButtonClick = () => {
    this.setState((state) => {
      return {
        open: !state.open,
        menuClass: this.state.menuClass === opened ? closed : opened,
      };
    });
  };

  handleClickOutside = (event) => {
    if (event.target.classList.contains("mdn-Link")) return;
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  shiftTabPressed = (event) => {
    if (
      event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "minhaClaroMovel"
    ) {
      this.closeMenu(event);
    }

    if (
      !event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "minhaClaroSair"
    ) {
      this.closeMenu(event);
    }

    if (
      event.shiftKey &&
      event.keyCode === 9 &&
      event.target.id === "mdn-Header"
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  closeMenu = (event) => {
    if (
      this.container.current &&
      !this.container.current.contains(event.target)
    ) {
      this.setState({
        open: false,
        menuClass: closed,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("keydown", this.shiftTabPressed, false);
  }
  logoutFn = async (ev) => {
    this.setState({
      loading: true,
    });
    await endSession();
    ev.preventDefault();
    cookies.remove("accesstoken", {
      domain: getDomainName(window.location.hostname),
    });

    document.location.href = logoutLink;

  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("keydown", this.shiftTabPressed, false);
  }

  render() {


    return (
      <><Loading isLoading={this.state.loading} /><ul className="cred-ProfileMenuList" ref={this.container}>
        <li className={this.state.menuClass} onClick={this.handleButtonClick}>
          <div className="cred-ProfileMenuTriggerWrapper">
            <Button
              type="button"
              aria-label="Abrir menu do perfil"
              aria-expanded={this.state.open}
              className="cred-ProfileTriggerButton"
              id="mdn-Header"
              tabIndex="9"
            >
              <span
                className="cred-ProfileTriggerContent"
                title="Menu"
              >
                <span className="cred-ProfileTriggerLabel">
                  {this.props.globalState.state.user &&
                    this.props.globalState.state.user.firstName
                    ? this.props.globalState.state.user.firstName
                    : "Cliente"}
                </span>

                <div className="cred-ProfileAvatar avatar-margin cred-icon-menu">
                  <i className="cred-ProfileAvatar-icon mdn-Icon--md mdn-Icon-minha-claro"></i>
                </div>
              </span>
            </Button>
          </div>
          <div className="cred-ProfileMenuDropdownEntrance">
            <div className="cred-ProfileMenuDropdown">
              <div className="cred-userMenu">
                <LinkDetailsIcons
                  links={[
                    {
                      target: "_blank",
                      link: "https://minhaclaro.claro.com.br/",
                      linkText: "Minha Claro",
                      content: "",
                      icon: "claro",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "minha-claro",
                      itemId: "minhaClaro",
                      tabIndex: "9",
                    },
                    {
                      target: "_blank",
                      link: "https://www.clarotvmais.com.br/home-landing",
                      linkText: "Minha Claro TV (Claro TV+)",
                      content: "",
                      icon: "tv",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "minha-claro-tv",
                      itemId: "minhaClaroTV",
                      tabIndex: "11",
                    },
                    {
                      target: "",
                      //  link: logoutLink,
                      onClick: this.logoutFn,
                      onBlur: this.shiftTabPressed,
                      linkText: "Sair",
                      content: "",
                      icon: "sair",
                      internal: false,
                      "data-gtm-event-category": "minha-claro:meu-perfil",
                      "data-gtm-event-action": "clique:menu-header",
                      "data-gtm-event-label": "sair",
                      itemId: "minhaClaroSair",
                      tabIndex: "12",
                    },
                  ]} />
              </div>
            </div>
          </div>
        </li>
      </ul></>
    );
  }
}

export default HeaderMenu;
